import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import publicRoutes from "./public";
import privateRoutes from "./private";

const NotFound = () => <h1>Not Found</h1>;
const Live = () => <p>App is live</p>;

// Combine all routes into one array
const router = createBrowserRouter([
  ...privateRoutes,
  ...publicRoutes,
  {
    path: "/live",
    element: <Live />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const ApolloRoutes = () => <RouterProvider router={router} />;

export default ApolloRoutes;
